module.exports = __webpack_public_path__ + "static/media/github.02aad9dd.svg";